// Races a promise against a timeout so an awaited call can never wedge the
// caller. On timeout the provided `onTimeout()` fallback value resolves the
// race instead of leaving the await pending forever.
//
// Used to harden Supabase auth/DB calls: auth no longer waits on
// navigator.locks (see lib/supabase/client.ts), but a network call can still
// stall on a dead connection — this guarantees the surrounding loading state
// always resolves.
export async function withTimeout<T>(
  promise: PromiseLike<T>,
  ms: number,
  onTimeout: () => T,
): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined
  try {
    return await Promise.race([
      Promise.resolve(promise),
      new Promise<T>((resolve) => {
        timer = setTimeout(() => resolve(onTimeout()), ms)
      }),
    ])
  } finally {
    if (timer) clearTimeout(timer)
  }
}

// Default ceiling for a single Supabase auth/profile call.
export const AUTH_CALL_TIMEOUT_MS = 8000
